import React from 'react'
import { EnergyKCal, RecipeLabel, RecipePoints, RecipePrice } from '../Kiosk/style'
import LabelIcons from '../LabelIcons/LabelIcons'
import { ActionButton, ActionButtons, Page } from '../PrintView/style'
import {
    LabelPage,
    ProductLabel,
    GlobalStyle,
    ProductLabelContent,
} from './style'

const LabelView = ({
    isAdmin,
    size,
    items,
    concept,
    hideLabels,
    hideIntolerences,
    hideMenuPrice,
    hideRecipePoints,
    hideEnergyKcal,
    showEnergyKcalByPortion,
    hideComposition,
    dataSource,
}) => {
    if (!items || items.length === 0) {
        return null
    }

    const flatProducts = []
    items.forEach((byDate) => {
        if (!byDate.kiosks) return
        byDate.kiosks.forEach(byKiosk =>
            byKiosk.items
                .filter(_ => _.menu_board_label)
                .forEach(item => flatProducts.push(item))
        )
    })

    if (flatProducts.length % 2 !== 0) {
        flatProducts.push([])
    }

    const priceRegex = /(\d+)[,|.](\d+)(.*)/

    const formatPrice = (price, currency) => {
        let priceInt, priceSup

        const priceMatches = priceRegex.exec(price)

        if (priceMatches) {
            priceInt = priceMatches[1]
            const decimals =
                parseInt(priceMatches[2]) !== 0 ? priceMatches[2] : ''
            priceSup = priceMatches[3].trim() + decimals
        } else {
            return (
                <span>
                    {price}
                    {currency}
                </span>
            )
        }

        return (
            <span>
                {priceInt}
                <span>{priceSup}</span>
            </span>
        )
    }

    return (
        <>
            <GlobalStyle />
            <LabelPage size={size} orientation={'portrait'}>
                {flatProducts.map((item, index) => (
                    <>
                        <ProductLabel
                            breakPage={index !== 0 && index % 7 === 0}
                            addMarginTop={index % 7 === 0}
                            small={hideComposition === true}
                        >
                            <ProductLabelContent>
                                <header>
                                    <img
                                        src={`img/concept/${concept}/logo-mobile.png`}
                                    ></img>
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'baseline',
                                        }}
                                    >
                                        <h1>
                                            <span>{item.menu_board_label}</span>
                                        </h1>

                                        {!!!hideComposition && (
                                            <div
                                                style={{
                                                    marginTop: '1mm',
                                                    fontSize: '10pt',
                                                }}
                                            >
                                                {item.composition}
                                            </div>
                                        )}
                                    </div>
                                </header>
                                <footer>
                                    {!hideLabels && item.label && (
                                        <RecipeLabel
                                            style={{
                                                height: '40px',
                                                margin: '0',
                                            }}
                                            src={`img/labels/${item.label}.png`}
                                            onError={i => (i.target.style.display = 'none')}
                                        />
                                    )}
                                    {!hideLabels &&
                                        item.caracteristique_produit && (
                                            <RecipeLabel
                                                style={{
                                                    height: '40px',
                                                    margin: '0',
                                                }}
                                                src={`img/labels/${item.caracteristique_produit}.png`}
                                                onError={i => (i.target.style.display = 'none')}
                                            />
                                        )}
                                    {!hideIntolerences && (
                                        <LabelIcons
                                            item={item}
                                            size={
                                                hideComposition
                                                    ? '24px'
                                                    : '32px'
                                            }
                                            dataSource={dataSource}
                                        />
                                    )}
                                    <div
                                        style={{
                                            marginLeft: 'auto',
                                            display: 'flex',
                                        }}
                                    >
                                        {!hideEnergyKcal && (
                                            showEnergyKcalByPortion ? (
                                                !!item.energyKCalByPortion && (
                                                    <EnergyKCal>
                                                        <span>{item.energyKCalByPortion}</span>
                                                    </EnergyKCal>
                                                )
                                            ) : (
                                                !!item.energyKCal && (
                                                    <EnergyKCal>
                                                        <span>
                                                            {item.energyKCal}
                                                            <sup style={{ marginLeft: '0.2em', fontSize: '0.6em' }}>100g</sup>
                                                        </span>
                                                    </EnergyKCal>
                                                )
                                            )
                                        )}
                                        {!hideRecipePoints && item.price_point ? (
                                            <RecipePoints>
                                                <span>{item.price_point}</span>
                                            </RecipePoints>
                                        ) : null}
                                        {!hideMenuPrice &&
                                            (item.price_currency ||
                                                !!item.price) && (
                                                <RecipePrice
                                                    style={{
                                                        marginLeft: '1mm',
                                                    }}
                                                >
                                                    {formatPrice(
                                                        item.price_currency ||
                                                            item.price,
                                                        item.currency
                                                    )}
                                                </RecipePrice>
                                            )}
                                    </div>
                                </footer>
                            </ProductLabelContent>
                        </ProductLabel>
                    </>
                ))}
            </LabelPage>
            {!isAdmin && (
                <ActionButtons>
                    <ActionButton onClick={() => window.print()}>
                        PRINT
                    </ActionButton>
                </ActionButtons>
            )}
        </>
    )
}

export default LabelView
